import styled from "styled-components";

export const Root = styled.div`
  font-size: 1.4rem;
`;

export const Title = styled.h2`
  margin: 0 0 4rem 0;
`;

export const Options = styled.div`
  margin: 0 0 4rem 0;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: right;
`;
